<template>
  <div class="contenTanel" v-loading="loading">
    <div class="header">
      <div class="title">
        {{ query.roleName }}
      </div>
      <div>
        <el-button class="green-btn" size="medium" @click="submit">保存</el-button>
        <el-button size="medium" @click="cancel">取消</el-button>
      </div>
    </div>
    <div class="content">
      <div class="leftTree">
        <el-tree
          ref="leftTree"
          :data="leftNodeList"
          default-expand-all
          show-checkbox
          node-key="nodeId"
          :props="defaultProps"
          :default-checked-keys="defaultChecked"
        >
        </el-tree>
      </div>
      <div class="treeCenter">
        <el-button class="green-btn" size="medium" @click="getBindTreeData">绑定</el-button>
      </div>
      <div class="rightTree">
        <el-tree ref="rightTree" :data="rightNodeList" default-expand-all node-key="nodeId" :props="defaultProps"> </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import moment from 'moment';
export default {
  name: 'DataPermissionConfiguration',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      leftNodeList: [],
      rightNodeList: [],
      checkedKeys: [],
      treeList: [],
      query: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  computed: {
    originCheckedData() {
      // 原始勾选节点
      let flatTreeData = this.flatTreeData() || [];
      let checked = flatTreeData.filter((v) => v.hasAuth != 'false').map((v) => v.nodeId);
      return checked;
    },
    defaultChecked() {
      // v.children.length===0 排除掉非叶子节点
      // 因为父子联动，父节点默认是半选状态，保存的时候会获取到半选状态的节点
      let flatTreeData = this.flatTreeData();
      let checked = flatTreeData.filter((v) => v.hasAuth != 'false' && v.children.length === 0).map((v) => v.nodeId);
      return checked;
    },
  },
  watch: {
    $route: {
      handler(val, olv) {
        var query = val.query.row ? JSON.parse(val.query.row) : {};
        if (
          olv.path == '/configurationCenter/dataPermissionManagement' &&
          query.id != this.query.id &&
          JSON.stringify(val.query) != '{}'
        ) {
          this.query = query;
          this.getConfigListPage();
        }
      },
    },
  },
  mounted() {
    this.query = JSON.parse(this.$route.query.row);
    this.getConfigListPage();
  },
  methods: {
    getConfigListPage() {
      let data = {
        roleCode: this.query.roleCode || '',
      };
      this.$q.configurationCenter.configListPage({ data: data }).then((res) => {
        this.leftNodeList = res.data;
        this.treeList = JSON.parse(JSON.stringify(res.data))
        this.$nextTick((_) => {
          this.getBindTreeData();
        });
      });
    },
    // 源数据扁平化
    flatTreeData() {
      return this.tree2flat(this.treeList);
    },
    getBindTreeData() {
      let data = this.$refs['leftTree'].getCheckedNodes(false, true).map((v) => {
        delete v['children'];
        return v;
      });
      console.log(data);
      data = this.transTreeData(data);
      this.rightNodeList = data;
    },
    transTreeData(items) {
      if (items.length > 0) {
        var curPid = 0; //pid=0，为最上层节点 ，即无父节点
        var parent = this.findChild(curPid, items); //数组
        return parent;
      } else {
        return [];
      }
    },
    //找子节点
    findChild(curPid, data) {
      var _arr = [];
      var items = data;
      var length = items.length;
      for (var i = 0; i < length; i++) {
        if (items[i]['parentId'] == curPid) {
          var _obj = items[i];
          _obj['children'] = this.findChild(_obj['nodeId'], items);
          _arr.push(_obj);
        }
      }
      return _arr;
    },
    // tree数据转平级
    tree2flat(source) {
      let res = [];
      const fn = (source) => {
        source.forEach((el) => {
          res.push(el);
          el.children && el.children.length > 0 ? fn(el.children) : '';
        });
      };
      fn(source);
      return res;
    },
    submit() {
      this.checkedKeys = this.$refs['leftTree'].getCheckedNodes(false, true).map((v) => v.nodeId);
      let data = this.getData();
      if(!data.length) {
        this.$message.error('请进行权限配置后在进行保存！')
        return
      }
      this.loading = true;
      this.$q.configurationCenter
        .configAddConfig({ data: data })
        .then((res) => {
          if (res.success) {
            this.$message.success('保存成功');
            this.cancel();
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    getData() {
      let originCheckedData = this.originCheckedData;
      console.log('原始勾选节点', originCheckedData);
      let checkedKeys = this.checkedKeys;
      console.log('勾选节点', checkedKeys);
      // 两数组交集
      let intersectionNodes = checkedKeys.filter((v) => {
        return originCheckedData.indexOf(v) > -1;
      });
      console.log('两数组交集', intersectionNodes);

      // 勾选数据
      let checkedData = checkedKeys.filter((v) => intersectionNodes.indexOf(v) === -1);
      var flatTreeData = this.flatTreeData() || [];
      checkedData = flatTreeData.filter((v) => checkedData.indexOf(v.nodeId) > -1);
      checkedData = checkedData.map((v) => {
        return {
          status: 'Y',
          nodeId: v.nodeId,
          code: v.code,
          roleCode: this.query.roleCode,
        };
      });
      console.log('勾选数据', checkedData);
      // 取消勾选数据 
      let uncheckedData = originCheckedData.filter((v) => intersectionNodes.indexOf(v) === -1);
      uncheckedData = flatTreeData.filter((v) => uncheckedData.indexOf(v.nodeId) > -1);
      uncheckedData = uncheckedData.map((v) => {
        return {
          status: 'N',
          nodeId: v.nodeId,
          code: v.code,
          roleCode: this.query.roleCode,
        };
      });
      console.log('取消勾选数据', uncheckedData);
      let data = [...checkedData, ...uncheckedData];
      return data
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route);
      this.$router.push({ name: 'DataPermissionManagement', params: {type: true} });
    },
  },
};
</script>

<style lang="stylus" scoped>
.contenTanel{
  width: calc(100% - 50px)
  height: calc(100% - 50px)
  padding: 20px
  margin: 5px
  border-radius: 5px
  background: #fff
}
.header {
  height: 30px
  display: flex
  justify-content: space-between
  align-items: center
  .title {
    font-size: 20px
    font-weight: bold
  }
}
.content {
  padding: 20px 0px 0 0px
  height: calc(100% - 50px)
  width: 100%
  display: flex
    .leftTree {
      flex: 1
      overflow-y: auto
    }
    .treeCenter {
      width: 10%
      text-align: center
      margin-top: 25vh
    }
    .rightTree {
      flex: 1
      overflow-y: auto
    }
}

>>> .el-tree-node__content {
  height: 36px;
  border-bottom: 1px solid #eee;
}
</style>
